<template>
    <div class="light-grey-bg">
    <v-container>
        <v-layout row wrap justify-center class="program">
            <v-flex xs12>
                <p class="small-title"><a @click="$router.push({name: 'programs'})">Programs</a></p>
            </v-flex>
            <v-flex xs12 class="program-title">
                <h1 >First Steps 4K+</h1>
            </v-flex>
            <v-flex md8>
                <v-card class="program-info" style="margin: 0 auto;">
                    <img class="program-image" src="/images/first-steps-4K-logo.png" />
                    <v-card-title>
                        <v-layout row wrap>
                            <v-flex xs12 align-self-center align-center>
                                <div style="margin: 0 auto;">
                                    <table>
                                        <tr>
                                            <td><img src="/images/icons/day.png"/></td>
                                            <td>Length of Day</td>
                                            <td>Extended Day, Full Day</td>
                                        </tr>
                                        <tr>
                                            <td><img src="/images/icons/year.png"/></td>
                                            <td>Length of Year</td>
                                            <td>School Year, Year-Round, Summer Options</td>
                                        </tr>
                                        <tr>
                                            <td><img src="/images/icons/car.png"/></td>
                                            <td>Transportation</td>
                                            <td>Varies</td>
                                        </tr>
                                        <tr>
                                            <td><img src="/images/icons/curriculum.png"/></td>
                                            <td>Curriculum</td>
                                            <td><img src="/images/icons/check.png"/></td>
                                        </tr>
                                        <tr>
                                            <td><img src="/images/icons/cost.png"/></td>
                                            <td>Cost</td>
                                            <td>Free</td>
                                        </tr>
                                        <tr>
                                            <td><img src="/images/icons/location.png"/></td>
                                            <td>Location</td>
                                            <td>Child Care Centers and Private Schools</td>
                                        </tr>
                                    </table>
                                </div>
                            </v-flex>
                            <v-flex class="program-overview" xs12>
                                <div style="margin: 0 auto; background: #1b3675;color: white;">
                                    <h3>Program Overview</h3>
                                    <p>
                                        First Steps 4K provides a quality pre-K experience for your four-year-old, plus child care for the whole family. With First Steps 4K, your child can attend a free full-day four-year-old kindergarten program at one of over 250 locations in South Carolina. 
                                        Options include licensed child care centers, charter schools, and private schools. First Steps 4K also qualifies your family for child care scholarships through the SC Working Families Child Care Scholarship program. These scholarships cover extended care for your 4K student, 
                                        as well as child care and afterschool programs for siblings up to age 12, at any child care or after-school program in the ABC Quality program. 
                                        To apply, first complete the First Steps 4K application. You'll receive the child care scholarship application after your First Steps 4K application is approved. 
                                        First Steps 4K is part of South Carolina's state-funded Child Early Reading Development and Education Program (CERDEP).
                                    </p>
                                </div>
                            </v-flex>
                            <v-flex xs12>
                                    <v-carousel>
                                      <v-carousel-item
                                        v-for="(item,i) in items"
                                        :key="i"
                                        :src="item.src"
                                      ></v-carousel-item>
                                    </v-carousel>                               
                            </v-flex>
                            <v-flex xs12 style="text-align: left">
                                <h3>Transportation Offered</h3>
                                <p>
                                    Transportation is offered at no cost by some centers.
                                </p>
                            </v-flex>
                            <v-flex xs12 style="text-align: left">
                                <h3>Curriculum</h3>
                                <p>
                                    Instructional curriculum includes Creative Curriculum by Teaching Strategies Gold®, and Conscious Discipline®.
                                </p>
                            </v-flex>
                            <v-flex xs12 style="text-align: left">
                                <h3>Cost</h3>
                                <p>
                                    Free
                                </p>
                            </v-flex>
                            <v-flex xs12 style="text-align: left">
                                <h3>Eligibility for Services</h3>
                                <p>
                                    Children must be 4 years old on or before September 1, eligible for
                                    Medicaid or below 185% poverty, or eligible for SNAP, TANF, or experiencing
                                    homelessness, transiency, or in foster care. Check eligibility at <a target="_blank" href="http://www.free4ksc.org">Free4KSC.org</a>.
                                </p>
                                <v-btn round large=true color="primary" @click="$router.push({name: 'eligibility'})"><span class="btn-white">Check Eligibility</span></v-btn>
                                <hr>
                            </v-flex>
                        </v-layout>        
                    </v-card-title>
                    <v-card-actions>
                        <v-btn flat color="primary" @click="$router.push({name: 'programs'})">&lt; Back to Programs</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
            <v-flex md4>
                <v-layout row wrap>
                    <v-flex class="" xs12>
                        <v-card class="contact-sidebar" color="primary" style="color: white;text-align:left;">
                            <v-card-title>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <h2>Contact</h2>
                                            <p class="bold">636 Rosewood Drive<br/>
                                            Columbia, SC 29201</p>
                                            
                                            <p>Phone: <a href="tel:803-734-0479"> 803-734-0479</a><br/>
                                            Toll Free: <a href="tel:877-621-0865"> 877-621-0865</a><br/>
                                            Fax: 803-734-1431<br/>
                                            Email: <a href="mailto:free4ksc@scfirststeps.org">Free4kSC@scfirststeps.org</a><br/><br/>
                                            Website: <a href="https://www.scfirststeps.org/what-we-do/programs/first-steps-4k/" target="_blank">Free4KSC.org</a></p>
                                    </v-flex>
                                </v-layout>
                            </v-card-title>
                        </v-card>
                    </v-flex>
                    <v-flex xs12>
                        <v-card class="quote-sidebar" color="lightblue" style="color: white;">
                            <v-card-title>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <img src="/images/icons/quote-icon.png"/>
                                        <p>
                                            “I appreciate beyond words that my child has a safe, happy place to learn while my husband and I work. It gives us the ability to focus on our jobs during the day. It also allows us to be focus on being the best parents we can be.”
                                        </p>
                                        <br/>
                                        <span>- Parent of a First Steps 4K+ Student</span>
                                    </v-flex>
                                </v-layout>
                            </v-card-title>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-container>
    <div class="grey-bg">
        <v-container>  
        <v-card>
            <v-card-title class="cta-card">
                <v-layout row wrap justify-center align-center>
                    <v-flex xs12 sm4 class="red-section">
                        <img alt="" src="/images/icons/icon.png"/>
                    </v-flex>
                    <v-flex xs12 sm8 class="cta-card-text">
                        <v-layout row wrap justify-center align-center>
                            <v-flex xs10>
                                <div class="red-section-content">
                                    <h2>Find Preschool Options Near You!</h2>
                                    <p>Find the preschools that offer programs for which your child is eligible. Simply enter your address to find a center located near you.</p>
                                </div>
                            </v-flex>
                            <v-flex xs2 class="arrow-img">
                                <a href="/provider-search"><img alt="Provider Search" src="/images/icons/arrow.png"/></a>
                            </v-flex>
                        </v-layout>  
                    </v-flex>
                </v-layout>
            </v-card-title>
        </v-card>
        </v-container>
    </div>
    </div>
</template>
<style scoped>
    .program{
        margin: 0 auto;
        text-align: center;
    }
    .red-section{
        background: #e94342;
        text-align: center;
    }

    .cta-card{
        padding: 0;    
    }

    .cta-card-text{
        padding: 15px 15px;
    }
</style>

<script>
     export default {
    data () {
      return {
        items: [
        {
            src: '/images/slides/fs4k-1.jpg'
          },
          {
            src: '/images/slides/fs4k.jpg'
          },
          {
            src: '/images/slides/fs4k-3.jpg'
          },
          {
            src: '/images/slides/2019_03_07_ANW4404.jpg'
          }
        ]
      }
    }
  }
</script>